import React from 'react';
import Home from '../pages/home';
import FileArchive from '../pages/file-archive';
import FontArchive from '../pages/font-archive';
import { RouteComponentProps } from 'react-router-dom';
import StandardPage from '../pages/standard-page';
import FontComponent from './font-component';
import FileComponent from './file-component';
import PhotoComponent from './photo-component';
import CategorisedArchive from '../pages/categorised-archve';
// import BusinessCardComponent from "./business-card-component";
import ColorComponent from './color-component';
import LabelComponent from './label-component';
import CodeComponent from './code-component';
import PhotoArchive from '../pages/photo-archive';
import { getChildren, getDataById } from '../helpers/api-helpers';
import LoadingSpinner from './loading-spinner';
import { hasCategories } from '../helpers/layout-helpers';
import StandardSection from '../pages/standard-section';
import TextComponent from '../components/text-component';
// export interface Page {
//     nodeId: string;
//     pageTitle: string;
//     pageSubtitle: string;
//     pageDescription: string;
//     pageContent: string;
//     name: string;
//     url: string;
//     type: string;
//     key: string;
//     data: PageData;
// }

export interface PageData {
  children: PageItem[];
}

export interface PageItem {
  id: number;
  description: string;
  usageRestrictions: string;
  accreditationRequirements: string;
  key: string;
  type?: string;
  selected?: boolean;
  onClick?: any;
  showCheckbox?: boolean;
  hideTitle: boolean;
  title?: string;
}

export interface PreviewImage {
  previewImageUrl: string;
  previewImageId: number;
  key: string;
}
export interface FileItem extends PageItem {
  filePath: string;
  fileUrl: string;
  file: any;
  darkBg: boolean;
  disableDownload?: boolean;
  fileExtension: string;
  hideTitle: boolean;
  previewImages: PreviewImage[];
}

export interface PageProps extends RouteComponentProps {
  id: number;
  key: string;
  slug: string;
  title: string;
  type: string;
  url: string;
  pageContent: any;
  subtitle: string;
  description: string;
  treeChildren?: PageProps[];
  itemChildren?: PageItem[];
  component?: React.ComponentType;
  selectedItems?: any[];
  deSelectAll?: any;
  mainTitle?: string;
  pageDescription?: string;
  sideMenuTitle?: string;
  columns?: number;
  hideTitle: boolean;
}

export interface ComponentSwitcherState {
  loading: boolean;
  data: any;
  itemChildren?: PageItem[];
  selectedItems: PageItem[];
}

class PageContainer extends React.Component<PageProps, ComponentSwitcherState> {
  constructor(props: PageProps) {
    super(props);
    this.state = { loading: true, data: null, selectedItems: [] };
    this.selectItem = this.selectItem.bind(this);
    this.deselectItem = this.deselectItem.bind(this);
    this.onClick = this.onClick.bind(this);
    this.isSelected = this.isSelected.bind(this);
    this.deSelectAll = this.deSelectAll.bind(this);
  }

  async getData(pageId: number) {
    const data = await getDataById(pageId);
    const itemChildren = await getChildren(data.id);
    let state: ComponentSwitcherState = {
      data,
      loading: false,
      itemChildren,
      selectedItems: [],
    };
    if (itemChildren && itemChildren.length === 1) {
      state.selectedItems = itemChildren;
    }
    this.setState(state);
  }

  pageTypeKey: any = {
    Kunde: Home,
    LogoArchive: FileArchive,
    FontArchive: FontArchive,
    PhotoArchive: PhotoArchive,
    BackgroundArchive: StandardPage,
    IllustrationArchive: FileArchive,
    BusinessCardArchive: FileArchive,
    LetterheadArchive: FileArchive,
    PpttemplateArchive: FileArchive,
    LabelArchive: StandardPage,
    ColorPaletteArchive: (props: any) =>
      hasCategories(props.itemChildren) ? (
        <CategorisedArchive {...props} />
      ) : (
        <StandardPage {...props} />
      ),
    EmailSignatureArchive: StandardPage,
    Section: StandardSection,
    TextComponent: (props: any) => <TextComponent {...props} />,
  };

  componentTypeKey: any = {
    Kunde: Home,
    LogoArchive: FileComponent,
    FontArchive: FontComponent,
    PhotoArchive: PhotoComponent,
    BackgroundArchive: FileComponent,
    IllustrationArchive: FileComponent,
    BusinessCardArchive: FileComponent,
    LetterheadArchive: FileComponent,
    PpttemplateArchive: FileComponent,
    LabelArchive: LabelComponent,
    EmailSignatureArchive: CodeComponent,
    ColorPaletteArchive: ColorComponent,
    TextComponent: TextComponent,
  };

  componentDidMount() {
    // window.addEventListener("media-query-resize", () => this.forceUpdate);
    this.getData(this.props.id);
  }

  componentWillUnmount() {
    // window.removeEventListener(
    //     "media-query-resize",
    //     () => this.forceUpdate
    // );
  }

  selectItem(id: number) {
    const item = this.state.itemChildren?.find((item) => item.id === id);
    if (!item) {
      return;
    }
    this.setState({ selectedItems: [...this.state.selectedItems, item] });
  }

  deselectItem(id: number) {
    this.setState({
      selectedItems: this.state.selectedItems.filter((item) => item.id !== id),
    });
  }

  onClick(id: number) {
    if (this.isSelected(id)) {
      this.deselectItem(id);
    } else {
      this.selectItem(id);
    }
  }

  isSelected(id: number) {
    return this.state.selectedItems.some((item) => item.id === id);
  }

  deSelectAll() {
    this.setState({ selectedItems: [] });
  }

  // renderChildComponents(ChildComponent: any) {
  //     if (ChildComponent === undefined) {
  //         return null;
  //     }
  //     const children = this.state.itemChildren?.map(item => {
  //         item.selected = this.isSelected(item.id);
  //         item.onClick = this.onClick.bind(this);
  //         return item;
  //     })
  //     return children?.map((item: PageItem) => (
  //         <ChildComponent {...item} />
  //     ));
  // }

  render() {
    let Component = this.pageTypeKey[this.props.type];
    let ChildComponent = this.componentTypeKey[this.props.type];
    if (this.state.loading) {
      return <LoadingSpinner />;
    }

    const children = this.state.itemChildren?.map((item) => {
      let totalItems = this.state.itemChildren?.length;
      if (totalItems) {
        item.selected = this.isSelected(item.id);
        item.onClick = this.onClick;
        item.selected = this.isSelected(item.id);
        item.hideTitle = this.props.hideTitle;
        item.showCheckbox =
          this.state.selectedItems.length > 0 && totalItems > 1;
      }
      return item;
    });

    return (
      <Component
        {...this.props}
        {...this.state?.data}
        deSelectAll={this.deSelectAll}
        selectedItems={this.state.selectedItems}
        itemChildren={children}
        component={ChildComponent}
      />
    );
  }
}

export default PageContainer;
